/**
 * @name responsive-state
 * @description Core responsive-state provider in ngx-responsive
 *
 * @license MIT
 */
export * from './responsive-state';
